'use strict';

exports.aggregateFunction = aggregateFunction.toString();
exports.aggregateCombineFunction = aggregateCombineFunction.toString();
exports.aggregateResetFunction = aggregateResetFunction.toString();


function aggregateFunction(accumulator, flag) {
    return accumulator > 0 || flag > 0;
}

function aggregateCombineFunction() {
    var i;
    var result = false;
    for (i = 0; i < arguments.length; i++) {
        result = result || arguments[i] > 0;
    }
    return result;
}

function aggregateResetFunction() {
    return 0;
}